import React, { useEffect, useRef } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import { useUIStore } from '../../store';

const DashboardLayout = () => {
  const { sidebarOpen, toggleSidebar, isMobile, setIsMobile, setSidebarOpen } = useUIStore();
  const navigate = useNavigate();
  const location = useLocation();
  const previousIsMobile = useRef(null);

  useEffect(() => {
    const checkViewport = () => {
      const nextIsMobile = window.innerWidth < 1024;
      setIsMobile(nextIsMobile);

      if (previousIsMobile.current === null || previousIsMobile.current !== nextIsMobile) {
        setSidebarOpen(!nextIsMobile);
      }

      previousIsMobile.current = nextIsMobile;
    };

    checkViewport();
    window.addEventListener('resize', checkViewport);
    return () => window.removeEventListener('resize', checkViewport);
  }, [setIsMobile, setSidebarOpen]);

  const handleNavigate = (path) => {
    if (location.pathname !== path) {
      navigate(path);
      const mainEl = document.getElementById('main-content');
      if (mainEl) mainEl.scrollTop = 0;
    }

    if (isMobile && sidebarOpen) {
      toggleSidebar();
    }
  };

  return (
    <div className="relative flex h-screen w-full overflow-hidden bg-[#edf6f7] text-slate-900 selection:bg-cyan-600 selection:text-white">
      <Sidebar
        isOpen={sidebarOpen}
        onToggle={toggleSidebar}
        onNavigate={handleNavigate}
        isMobile={isMobile}
      />

      {isMobile && !sidebarOpen && (
        <button
          onClick={toggleSidebar}
          className="fixed left-5 top-5 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-white/60 bg-white/90 text-[#0b1f3a] shadow-[0_8px_32px_rgba(15,23,42,0.12)] backdrop-blur-xl ring-1 ring-black/5 transition-all duration-300 hover:scale-105 hover:bg-white active:scale-95"
          aria-label="Open navigation"
        >
          <Menu size={20} strokeWidth={2.5} />
        </button>
      )}

      <main
        id="main-content"
        className="custom-scrollbar h-full min-w-0 flex-1 overflow-y-auto overflow-x-hidden scroll-smooth"
      >
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
